const Service = () => {
  const serviceList = [
    {
      img: "/images/service1.png",
      name: "유품정리 서비스",
      // txt2: '오래경험과 노하우 + 최신장비를 활용하여',
      // txt3: '보다 높은 확률로 탐지해냅니다.',
      // link: "https://blog.naver.com/PostList.naver?blogId=rna0186&from=postList&categoryNo=24",
    },
    {
      img: "/images/service2.png",
      name: "쓰레기집청소 서비스",
    },
    {
      img: "/images/service3.png",
      name: "특수청소 서비스",
    },
    {
      img: "/images/service4.png",
      name: "고독사청소 서비스",
    },
    {
      img: "/images/service5.png",
      name: "빈집정리 서비스",
    },
    {
      img: "/images/service6.png",
      name: "창고정리 서비스",
    },
    {
      img: "/images/service7.png",
      name: "이사정리 서비스",
    },
    {
      img: "/images/service8.png",
      name: "폐기물처리 서비스",
    },
    {
      img: "/images/service9.png",
      name: "철거 · 원상복구 서비스",
    },
  ];

  return (
    <div
      id="service"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20"
      >
        <h3 className="font-normal text-black">서비스 목록</h3>
        <p className="text-secondary my-3 lg:text-lg">- SERVICE -</p>
        <p className="lg:text-lg text-black">
          다양한 정리와 특수청소 서비스를
          한&nbsp;곳에서&nbsp;한번에&nbsp;해결해보세요
        </p>
      </div>
      <div className="relative w-full h-fit max-w-[1300px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
        {serviceList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            className="relative w-full h-full mb-5"
          >
            <div className="relative w-full h-fit p-3 border rounded-3xl btn6 inline-block">
              <div className=" relative w-full h-fit my-3 xl:my-5">
                <p className="text-sm text-secondary mb-1 xl:mb-2">
                  SERVICE-0{i + 1}
                </p>
                <p className="gmedium text-2xl 2xl:text-3xl text-black mb-3">
                  {v.name}
                </p>
              </div>
              <div className="relative w-full h-fit rounded-3xl overflow-hidden">
                <img
                  className="!relative w-full h-full object-cover object-center transition-transform duration-300"
                  alt={`집치워드림센터 ${v.name}`}
                  src={v.img}
                  width={611}
                  height={589}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
